import { createFileRoute } from "@tanstack/react-router";
import { MyTemplates } from "../../../../../../features/consent-solutions/features/pop-up-templates/components/consent-popup-list/components/my-templates";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/popup/my-templates/")({
  component: () => <MyTemplates />,
});

export { Route };
